import styled from 'styled-components';

export const MarkerWrapper = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MarkerLabel = styled.span<{ color: string; isActive: boolean }>`
  background: white;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 10px;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  margin-top: -12px;
  z-index: 1;
  border: 1px solid ${props => props.color};
  opacity: ${props => (props.isActive ? 1 : 0.8)};
`;

export const PopupContainer = styled.div`
  padding: 5px;
  color: #333;
  font-size: 12px;
  line-height: 1.3;
  border-radius: 4px;
`;

export const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
  border-bottom: 1px solid #eee;
  padding-bottom: 3px;

  strong {
    font-size: 13px;
  }
`;

export const StatusBadge = styled.span<{ isActive: boolean }>`
  font-size: 9px;
  padding: 1px 5px;
  border-radius: 10px;
  background: ${props => (props.isActive ? '#e6f4ea' : '#feeaee')};
  color: ${props => (props.isActive ? '#1e7e34' : '#d93025')};
  font-weight: bold;
`;

export const LineName = styled.p<{ color?: string }>`
  margin: 0;
  font-weight: bold;
  color: ${props => props.color || '#333'};
  font-size: 11px;
`;

export const InfoBox = styled.div`
  background: #f9f9f9;
  border-radius: 4px;
  font-size: 12px;

  div {
    margin-bottom: 0;
  }
`;

export const GoogleMapsLink = styled.a`
  display: inline-block;
  margin-top: 5px;
  color: #007cbf;
  text-decoration: none;
  font-weight: bold;
  font-size: 9px;
  border: 1px solid #007cbf;
  padding: 1px 5px;
  border-radius: 4px;

  &:hover {
    background: #007cbf;
    color: white;
  }
`;
